import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReferenceDataLabels } from '../../../lib/constants/reference-data-labels';
import { ValidationErrors } from '../../../lib/models/validation/validation-errors';

@Component({
  selector: 'boi-term-input',
  templateUrl: './term-input.component.html',
  styleUrls: ['./term-input.component.scss']
})
export class TermInputComponent {
  @Input() public controlId: any;
  @Input() public labelName: string;
  @Input() public tooltipName: string;
  @Input() public contextualHelpName: string;
  @Input() public isFieldDisabled: boolean;
  @Input() public years?: number;
  @Input() public months?: number;
  @Input() public validationPropertyNames: Array<string>;
  @Input() public validationErrors: ValidationErrors;
  @Input() public addTitleToInputs = true;
  @Input() public cssClasses = 'label-top label-weight-bold label-font-size-13';
  @Output() public readonly yearsChange = new EventEmitter<number>();
  @Output() public readonly monthsChange = new EventEmitter<number>();
  public referenceDataLabels = ReferenceDataLabels;
  public hasErrors = false;
}
